import warn from './warn';
export default (componentName, oldProp, newProp) => {
  warn(`${componentName}: ${oldProp} is deprecated and will be removed, use ${newProp} instead`, true);
};
//# sourceMappingURL=deprecate.js.map